import find from 'lodash/find'
import Profile from '@models/Profile/model'
import Collection from '@models/Collection'

export default class ProfileCollection extends Collection {
  findCurrentProfile () {
    return find(this.$models, { current: true })
  }

  getModel () {
    return Profile
  }

  switchProfile (userId, profile) {
    return this.request('PUT', `users/${userId}`, { selectedProfileId: profile.id })
  }
}



// WEBPACK FOOTER //
// ./src/models/Profile/collection.js